import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import moment from "moment";
import "moment/locale/pt-br";
import "moment/locale/es";
import { messages } from "./languages";

const momentLocaleMap = { pt: "pt-br", es: "es", en: "en" };

const syncMomentLocale = (lng) => {
  const short = (lng || "").substring(0, 2);
  moment.locale(momentLocaleMap[short] || "pt-br");
};

// Detectar idioma de forma segura (sem depender de localStorage que pode ser bloqueado)
let detectedLng = "es";
try {
  const stored = localStorage.getItem("i18nextLng");
  if (stored) {
    const short = stored.substring(0, 2);
    if (messages[short]) {
      detectedLng = short;
    }
  }
} catch (e) {
  // localStorage bloqueado pelo Tracking Prevention - mantém "es" como padrão
  // NÃO usar navigator.language pois pode retornar "en" e quebrar a experiência
}

i18n
  .use(initReactI18next)
  .init({
    debug: false,
    lng: detectedLng,
    fallbackLng: "es",
    defaultNS: ["translations"],
    ns: ["translations"],
    resources: messages,
    interpolation: {
      escapeValue: false, // React já faz escape — evita "/" virar "&#x2F;"
    },
  });

syncMomentLocale(detectedLng);

// Salvar mudança de idioma quando possível
i18n.on("languageChanged", (lng) => {
  syncMomentLocale(lng);
  try {
    localStorage.setItem("i18nextLng", lng);
  } catch (e) {
    // storage bloqueado, ignora
  }
});

export { i18n };
